import { useState } from 'react';

import useIsMounted from '@chama/ui-components/hooks/useIsMounted';

export default function useNotifications() {
  const [notifications, setNotifications] = useState({});
  const isMounted = useIsMounted();

  const addNotification = notification => {
    setNotifications(oldNotifications => {
      const key = Date.now();
      const newNotifications = { ...oldNotifications };
      newNotifications[key] = { ...notification, id: key };
      setTimeout(id => removeNotification(id), 5000, key);
      return newNotifications;
    });
  };

  const removeNotification = id => {
    if (!isMounted.current) return;

    setNotifications(oldNotifications => {
      const newNotifications = { ...oldNotifications };
      delete newNotifications[id];
      return newNotifications;
    });
  };

  return [notifications, addNotification];
}



// WEBPACK FOOTER //
// ../ui-components/components/MapNotifications/hooks/useNotifications.js